import api from './api';

const errorReportsApi = {
  list: () => api.get('/system/error-reports'),
  acknowledge: (id) => api.post(`/system/error-reports/${id}/acknowledge`)
};

export default errorReportsApi;
